import { render, staticRenderFns } from "./DefaultDocumentToStore.vue?vue&type=template&id=7878f96c&scoped=true&"
import script from "./DefaultDocumentToStore.vue?vue&type=script&lang=ts&"
export * from "./DefaultDocumentToStore.vue?vue&type=script&lang=ts&"
import style0 from "./DefaultDocumentToStore.vue?vue&type=style&index=0&id=7878f96c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7878f96c",
  null
  
)

export default component.exports